import { useContext } from "react";
import { BurgerButtonBig, ButtonRound, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './Start.css';
import { LocaleContext, ScrollContext } from "../common/App";
import { FaqQuestion, Footer } from "./WebsiteCommon";
import { useIndexUpdate, useNavigateSmart } from "../common/hooks";
import { UserType } from "../common/enums.mjs";
import { WebsiteContext } from "./WebsiteApp";

export function Start(props) {
    const locale = useContext(LocaleContext);
    const website = useContext(WebsiteContext);
    const scroll = useContext(ScrollContext);

    const navigate = useNavigateSmart();

    useIndexUpdate(props.indexUpdate, locale);


    // RENDER:

    const locationUpper = props.location.toUpperCase();

    return (
        <div className="start_box head_img">
            <img className="img_width" src={"/customer/images/start_1_" + props.location + ".jpg"} alt={locale.msgs["START_IMG_1_ALT_TEXT_" + locationUpper]}></img>
            <div className="text_box">
                { locale.msgs["START_HEAD_1_2_H1_" + locationUpper] ? [
                    <div className="text_big_big head_after_img">{locale.msgs["START_HEAD_1_1_" + locationUpper]}</div>,
                    <h1 className="text_big_big start_head_2">{locale.msgs["START_HEAD_1_2_H1_" + locationUpper]}</h1>
                ] :
                    <h1 className="text_big_big head_after_img">{locale.msgs["START_HEAD_1_1_" + locationUpper]}</h1>
                }
                
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs["START_TEXT_1_" + locationUpper]}}></div>

                <LearnMore onClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/about_us/");
                            }}/>

                <div id="how_brokerage_works" className="text_big_big">{locale.msgs["START_HEAD_2_" + locationUpper]}</div>
            </div>

            <img className="img_width margin_top_low_low" src={"/customer/images/start_2_" + props.location + ".jpg"}
                    alt={locale.msgs["START_IMG_2_ALT_TEXT_" + locationUpper]}></img>

            <div className="text_box">
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs["START_TEXT_2_" + locationUpper]}}></div>

                <LearnMore onClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/how_it_works/");
                            }}/>

                <div id="find_m_n">
                    <SignupBox header={locale.msgs["START_HEAD_3_" + locationUpper]} descr={locale.msgs["START_TEXT_3_" + locationUpper]}
                            onClick={() => {
                                website.setRegisterInfo({...website.registerInfo, "userType": UserType.FAMILY});
                                navigate("/register/");
                            }} />
                </div>
                
                <div id="find_job">
                    <SignupBox header={locale.msgs["START_HEAD_4_" + locationUpper]} descr={locale.msgs["START_TEXT_4_" + locationUpper]}
                            onClick={() => {
                                website.setRegisterInfo({...website.registerInfo, "userType": UserType.NANNY});
                                navigate("/register/");
                            }} />
                </div>
            </div>

            <img className="margin_top_high img_width" src={"/customer/images/start_3_" + props.location + ".jpg"}
                    alt={locale.msgs["START_IMG_3_ALT_TEXT_" + locationUpper]}></img>

            {/*
            <div className="text_box_gray">
                <div id="academy" className="text_big_big">{locale.msgs.OUR_ACADEMY}</div>
                <div className="text">{locale.msgs.OUR_ACADEMY_DESCR}</div>
                <LearnMore href="/login/"/>
            </div>
            */}

            <div id="all_for_all_box" className="text_box">
                <div className="text_big_big">{locale.msgs["START_HEAD_5_" + locationUpper]}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs["START_TEXT_5_" + locationUpper]}}></div>
            </div>

            { locale.msgs["START_HEAD_6_" + locationUpper] ?
                <div id="start_faq_box" className="text_box">
                    <h2 className="text_big_big">{locale.msgs["START_HEAD_6_" + locationUpper]}</h2>
                    
                    <div className="faq_question_box">
                        <FaqQuestion question={locale.msgs["START_FAQ_1_QUESTION_" + locationUpper]}
                                answer={locale.msgs["START_FAQ_1_ANSWER_" + locationUpper]}
                                open={false} noScrollOnOpen={false}
                        />

                        <FaqQuestion question={locale.msgs["START_FAQ_2_QUESTION_" + locationUpper]}
                                answer={locale.msgs["START_FAQ_2_ANSWER_" + locationUpper]}
                                open={false} noScrollOnOpen={false}
                        />

                        <FaqQuestion question={locale.msgs["START_FAQ_3_QUESTION_" + locationUpper]}
                                answer={locale.msgs["START_FAQ_3_ANSWER_" + locationUpper]}
                                open={false} noScrollOnOpen={false}
                        />

                        <FaqQuestion question={locale.msgs["START_FAQ_4_QUESTION_" + locationUpper]}
                                answer={locale.msgs["START_FAQ_4_ANSWER_" + locationUpper]}
                                open={false} noScrollOnOpen={false}
                        />

                        <FaqQuestion question={locale.msgs["START_FAQ_5_QUESTION_" + locationUpper]}
                                answer={locale.msgs["START_FAQ_5_ANSWER_" + locationUpper]}
                                open={false} noScrollOnOpen={false}
                        />

                    </div>
                </div>
            :
                null
            }

            <Footer />
        </div>
    );
}
